<template>
  <div v-if="url" class="gc-asset-url" :class="{ 'gc-asset-url--block': block }">
    <a
      class="gc-asset-url__link"
      :href="url"
      target="_blank"
      rel="noopener noreferrer"
    >{{ url }}</a>
    <v-btn
      class="gc-asset-url__copy"
      icon
      x-small
      aria-label="Copy URL"
      @click="$emit('copy')"
    >
      <v-icon x-small>mdi-content-copy</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'AssetUrlBar',

  props: {
    url: {
      type: String,
      default: ''
    },
    block: {
      type: Boolean,
      default: false
    }
  }
};
</script>
